// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PossibleChildClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, firstName: string, lastName: string, dateOfBirth?: Time | null };

export type GetChildrenQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type GetChildrenQuery = { __typename?: 'Query', clientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & PossibleChildClientProfileFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetChildren: 'GetChildren' as const
  },
  Fragment: {
    PossibleChildClientProfile: 'PossibleChildClientProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const PossibleChildClientProfileFragmentDoc = gql`
    fragment PossibleChildClientProfile on ClientProfile {
  id
  displayName
  firstName
  lastName
  dateOfBirth
}
    `;
export const GetChildrenDocument = gql`
    query GetChildren($householdId: ID!) {
  clientProfiles(
    where: {and: [{hasHouseholdWith: {id: $householdId}}, {hasRelationshipsWith: {type: CHILD}}]}
  ) {
    edges {
      node {
        ...PossibleChildClientProfile
      }
    }
  }
}
    ${PossibleChildClientProfileFragmentDoc}`;

/**
 * __useGetChildrenQuery__
 *
 * To run a query within a React component, call `useGetChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildrenQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useGetChildrenQuery(baseOptions: Apollo.QueryHookOptions<GetChildrenQuery, GetChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildrenQuery, GetChildrenQueryVariables>(GetChildrenDocument, withFetchPolicyContext(options));
      }
export function useGetChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildrenQuery, GetChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildrenQuery, GetChildrenQueryVariables>(GetChildrenDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetChildrenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChildrenQuery, GetChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChildrenQuery, GetChildrenQueryVariables>(GetChildrenDocument, withFetchPolicyContext(options));
        }
export type GetChildrenQueryHookResult = ReturnType<typeof useGetChildrenQuery>;
export type GetChildrenLazyQueryHookResult = ReturnType<typeof useGetChildrenLazyQuery>;
export type GetChildrenSuspenseQueryHookResult = ReturnType<typeof useGetChildrenSuspenseQuery>;
export type GetChildrenQueryResult = Apollo.QueryResult<GetChildrenQuery, GetChildrenQueryVariables>;